export const LuhnCheck = {
  methods: {
    LuhnCheck: function(value) {
      let sum = 0
      let parity = false
      let characters = value
        .replace(/\D/g, '')
        .split('')
        .reverse()

      characters.forEach(character => {
        let digit = parseInt(character)

        if (parity) digit = digit * 2 > 9 ? digit * 2 - 9 : digit * 2

        sum += digit
        parity = !parity
      })

      return sum % 10 === 0
    }
  }
}

export default {
  LuhnCheck
}
